import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { setRegion } from "../../shared/store/actions/advisor";
import { startApp } from "../../shared/store/actions/startup";
import RegionsWebUI from "../../components/Advisor/Regions";

class Regions extends Component {
  selectRegion = region => {
    this.props.setRegion(region.id).then(props => {
      const { i18n } = this.props;
      let language = region.language;

      if (region.language === "us") {
        language = "en";
      }

      i18n.changeLanguage(language);
      this.props.history.push("/sport-types");
    });
  };

  render() {
    return (
      <RegionsWebUI
        advisor={this.props.advisor}
        items={this.props.regions}
        onSelect={this.selectRegion}
        application={this.props.app}
        database={this.props.database}
        onReload={this.props.startApp}
      />
    );
  }
}

const mapStateToProps = state => ({
  regions: state.regions.data.filter(region => region.active),
  app: state.app,
  database: state.database,
  advisor: state.advisor
});

export default connect(
  mapStateToProps,
  { setRegion, startApp }
)(withNamespaces("common")(withRouter(Regions)));
